const rotas = {
     base: {
          "/automacao": "/automacao",
          "/lista-monitorados": "/lista-monitorado",
          "/supervisorio": "/supervisorio",
          "/cliente": "/cliente",
          "/perfil/cliente": "/cliente/perfil",
          "/usuario": "/usuario",
          "/perfil/usuario": "/usuario/perfil",
          "/acessos": "/acesso",
          "/exportacao-dados": "/exportacao-dados",
          "/equipamento": "/equipamento",
          "/monitorado": "/monitorado",
          "/virtual": "/equipamento",
          "/empresa": "/empresa",
          "/relatorio/logs": "/log-acessos",
          "/relatorio/analitico": "/relatorio",
          "/relatorio-customizado": "/relatorio",
          "/relatorio-consumo": "/relatorio/consumo",
          "/minha-conta": "/configuracao-timezone",
          "/configuracao-sistema": "/configuracao",
          "/relatorio-alertas": "/relatorio/alerta"
     },

     ambiental: {
          "/mira": "/mira",
          "/sideccr": "/sideccr",
          "/ana": "/ana",
          "/relatorio-inema": "/relatorio-ambiental-inema",
          "/relatorio-serhma": "/relatorio-ambiental-serhma",
          "/ambiental/outorga": "/ambiental/outorga",
          "/ambiental/dashboard": "/ambiental/dashboard",
          "/ambiental/relatorio/outorgas": "/ambiental/relatorio/outorgas",
     },

     lns: {
          "/lns/dashboard": "/lns/dashboard",
          "/lns/application": "/lns/application",
          "/lns/gateway": "/lns/gateway",
          "/lns/device/profile": "/lns/device/profile",
          "/lns/planos": "/lns/planos",
          "/lns/redirecionamentos": "/lns/redirecionamentos",
          "/lns/relatorio/faturamento": "/lns/relatorio/faturamento",
          "/lns/relatorio/gateway": "/lns/relatorio/gateway",
          "/lns/relatorio/dispositivo": "/lns/relatorio/dispositivo",
          "/lns/cadastro-rapido": "/lns/cadastro-rapido"
     }
}


export default rotas